export default __webpack_public_path__ + "static/media/contactPeople.46182047.svg";